<template>
  <div class='col organization-data'>

    <div class="vertical-field">

      <div class="field-label">
        Субъект права
      </div>

      <div>
        {{ application.organization.subjectName }}
      </div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        Наименование организации
      </div>

      <div>
        {{ application.organization.name }}
      </div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        ИНН
      </div>

      <div>
        {{ application.organization.inn }}
      </div>

    </div>

    <div class="vertical-field">

      <div class="field-label">
        Юридический адрес
      </div>

      <div>
        {{ application.organization.address }}
      </div>

    </div>

    <div class="data-row organization-data-gap">

      <div class="vertical-field">

        <div class="field-label">
          Телефон
        </div>

        <div>
          {{ application.organization.phone || '&nbsp;' }}
        </div>

      </div>

      <div class="vertical-field">

        <div class="field-label">
          Адрес электронной почты
        </div>

        <div>
          {{ application.organization.email || '&nbsp;' }}
        </div>

      </div>

      <div class="vertical-field">

        <div class="field-label">
          Сайт
        </div>

        <div>
          {{ application.organization.website || '&nbsp;' }}
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import applicationViewMixin from '../../../mixins/application-view/applicationViewMixin';
export default {
  mixins: [applicationViewMixin],

  props: {
    application: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.organization-data {
  gap: 16px;
  overflow-y: auto;
}

.organization-data-gap{
  gap: 32px;
}
</style>
